var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34967 13.2703C5.86226 12.3492 4.4798 11.2686 3.22683 10.0476C2.34127 9.16285 1.66712 8.0894 1.25474 6.90744C0.519506 4.60553 1.37844 1.97379 3.79717 1.19732C4.42385 0.996153 5.0896 0.947909 5.73872 1.05669C6.38785 1.16548 7.00147 1.42811 7.52833 1.8226C8.0544 1.42921 8.66685 1.16722 9.31467 1.05846C9.96249 0.949689 10.6269 0.997313 11.2526 1.19732C13.6713 1.97379 14.5372 4.63301 13.8019 6.90744C13.3915 8.09034 12.7171 9.1642 11.8298 10.0476C10.5769 11.2686 9.1944 12.3492 7.70699 13.2703L7.54209 13.3665L7.34967 13.2703Z",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0845 3.7876C10.4439 3.90274 10.7607 4.12248 10.9945 4.41871C11.2283 4.71493 11.3684 5.07417 11.3969 5.45046",
    stroke: "#6D7279",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/favIcon.1dba077e668cc8391c4f3e5b4f20ab07.svg";
export { ForwardRef as ReactComponent };